/* eslint-disable prefer-destructuring,func-names,react/prop-types  */

import React from 'react';
import styled from 'styled-components';
import { Drawer } from 'antd';

import DrawerFrame from '../../views/DrawerFrame';
import StyledTable from '../../views/StyledTable';
import Clamper from '../../views/ContentWidthClamper';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import ContentHeader from '../../views/ContentHeader';
import PageFrame from '../../views/PageFrame';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
  }
  
  .ant-drawer-body > section {
    display: flex;
    flex-direction: column;
  }
`;
export default (bottle) => {
  bottle.factory(
    'MediaBrowserView',
    ({ mediaBrowserColumns }) => ({
      title, onPlayMedia, onCloseDrawer, goHome, dataSource, children, editVisible, currentMediaItem, isLoading,
    }) => (
      <PageFrame className="media-browser-view">
        <Clamper>
          <ContentHeader>
            <HeadlineBreadcrumbList>
              {[
                { onClick: goHome, text: 'Home' },
                title,
              ]}
            </HeadlineBreadcrumbList>
          </ContentHeader>
          <StyledTable
            rowKey="mediaId"
            columns={mediaBrowserColumns(onPlayMedia)}
            dataSource={dataSource}
            loading={isLoading}
            pagination={false}
          />
          {dataSource && dataSource.length > 90 ? <p className="table-message">Returning a maximum of 100 media.</p>: null}
        </Clamper>
        <StyledDrawer
          title="Media Player"
          placement="right"
          closable
          width={600}
          onClose={onCloseDrawer}
          visible={editVisible}
          currentMediaItem={currentMediaItem}
        >
          <DrawerFrame>
            {children}
          </DrawerFrame>
        </StyledDrawer>
      </PageFrame>
    ),
  );
};
